// {{{ Supervisor.OverviewScreen

GW.define('Supervisor.OverviewScreen', 'Main.Screen', {
	title: _('Supervizor panel'),
	titleIcon: 'eye',

	'after:initComponent'() {
		this.bodyEl.gwReplaceChildren([{
			className: 'day-stats',
			xtype: 'Supervisor.DayStatsBar',
		},{
			className: 'tab-switcher',
			xtype: 'Widgets.TabSwitcher',
			ref: 'tabs',
			items: [{
				id: 'active-calls',
				title: _('Aktivní a čekající hovory'),
				href: APP_BASE + 'supervisor/active-calls',
			}, {
				id: 'agents',
				title: _('Agenti'),
				href: APP_BASE + 'supervisor/agents',
			}, {
				id: 'queues',
				title: _('Fronty'),
				href: APP_BASE + 'supervisor/queues',
			}, {
				id: 'callbacks',
				title: _('Callback'),
				href: APP_BASE + 'supervisor/callbacks',
			}, {
				id: 'queues-history',
				title: _('Historie front'),
				href: APP_BASE + 'supervisor/queues-history',
			}],
		}, {
			className: 'supervisor-content',
			xtype: 'Widgets.CardSwitcher',
			ref: 'cards',
		}], this);
	},

	async applyParams(params) {
		const screen = params.get('screen');
		const screens = {
			'active-calls': 'Supervisor.ActiveCallsScreen',
			'agents': 'Supervisor.AgentsScreen',
			'queues': 'Supervisor.QueuesScreen',
			'callbacks': 'Supervisor.CallbacksScreen',
			'queues-history': 'Supervisor.QueuesHistoryScreen',
		};

		this.tabs.setSelected(screen);

		if (screens[screen]) {
			await this.cards.show({
				id: screen,
				xtype: screens[screen],
				params,
			});
		}

		this.cards.prune();

		Application.refreshSubscriptionsFromDOM();
	},
});

// }}}
// {{{ Supervisor.DayStatsBar

GW.define('Supervisor.DayStatsBar', 'GW.Component', {

	expanded: false,

	// PLUGIN: extension point for defining wallboard to show in this component
	getWallboards() {
		return [];
	},
	
	'after:initComponent'() {
		const wallboards = this.getWallboards();
		this.el = document.gwCreateElement({
			className: 'js-msgbus',
			socketSubscriptions: ['call_updates'],
			children: [{
				ref: 'wrapEl',
				className: 'day-stats-wrap',
			}, {
				className: 'day-stats-controls',
				children: [{
					ref: 'buttonEl',
					nodeName: 'button',
					className: 'day-stats-btn secondary',
					'on:click': () => {
						this.expanded = !this.expanded;
						localStorage.setItem('day-stats-expanded', this.expanded);
						this.refreshExpandState();
					}
				}, {
					':skip': wallboards.length <= 0,
					nodeName: 'button',
					className: 'secondary',
					textContent: _('Wallboard'),
					'on:click': ev => {
						const showDialog = w => {
							new Main.Dialog({
								title: w.title,
								'after:initComponent'() {
									this.bodyEl.gwCreateChild({
										children: [{
											nodeName: 'button',
											className: 'transparent icon-only small',
											title: _('Kopírovat odkaz'),
											'on:click': async e => {
												await navigator.clipboard.writeText(w.link);
												Application.notify({
													kind: 'success',
													text: _('Odkaz zkopírován do schránky'),
												});
											},
											children: [Utils.useIcon('duplicate')],
										},{
											className: 'link',
											nodeName: 'a',
											target: '_blank',
											textContent: w.link,
											href: w.link,
										}]
									});
								},
							});
						};
						
						if (wallboards.length == 1) {
							showDialog(wallboards[0]);
						} else {
							let popup = new PopupMenu({
								options: wallboards.map(w => ({
									text: w.title,
									handle: () => showDialog(w)
								})),
							});
							PopupManager.show(popup, {
								anchorEl: ev.target.closest('button'),
								forceAxis: 'vertical',
								preferReadingOrder: true,
							});
						}
					}
				}]
			}]
		}, this);
		this.expanded = localStorage.getItem('day-stats-expanded') === 'true';
		this.refreshExpandState();
	},
	
	renderStats(data) {
		if (!this.expanded) return;
		data = data || {};

		this.wrapEl.gwReplaceChildren([{
			className: 'day-stats-box',
			children: [{
				className: 'day-stats-label',
				textContent: _('Celkem\nhovorů'),
			}, {
				className: 'day-stats-value',
				textContent: data.total_count || '',
			}, {
				title: data.trend,
				className: 'day-stats-icon',
				children: [Utils.useIcon(
					!data.trend || data.trend === 0 ? '' : data.trend > 0 ? 'arrow-up' : data.trend < 0 ? 'arrow-down' : 'error',
					{cls: !data.trend || data.trend === 0 ? 'muted' : data.trend > 0 ? 'error'    : data.trend < 0 ? 'success'    : 'muted'}
				)]
			}]
		}, {
			className: 'day-stats-box',
			children: [{
				className: 'day-stats-label',
				textContent: _('Dovolané'),
			}, {
				className: 'day-stats-value',
				textContent: data.count_connected || '',
			}]
		}, {
			className: 'day-stats-box',
			children: [{
				className: 'day-stats-label',
				textContent: _('Nedovolané'),
			}, {
				className: 'day-stats-value',
				textContent: data.count_not_connected || '',
			}]
		}, {
			className: 'day-stats-box',
			children: [{
				className: 'day-stats-label',
				textContent: _('Průměrně\nv IVR'),
			}, {
				className: 'day-stats-value',
				textContent: Formats.duration(data.avg_early_duration || 0),
			}]
		}, {
			className: 'day-stats-box',
			children: [{
				className: 'day-stats-label',
				textContent: _('Průměrné\nvyzvánění'),
			}, {
				className: 'day-stats-value',
				textContent: Formats.duration(data.avg_ring_duration || 0),
			}]
		}, {
			className: 'day-stats-box',
			children: [{
				className: 'day-stats-label',
				textContent: _('Průměrný\nhovor'),
			}, {
				className: 'day-stats-value',
				textContent: Formats.duration(data.avg_duration || 0),
			}]
		}, {
			className: 'day-stats-box',
			children: [{
				className: 'day-stats-label',
				textContent: _('Celková\ndoba hovorů'),
			}, {
				className: 'day-stats-value',
				textContent: Formats.duration(data.sum_duration || 0)
			}]
		}, {
			className: 'day-stats-box',
			children: [{
				className: 'day-stats-label',
				textContent: _('Service\nlevel'),
			}, (() => {
				let el = document.gwCreateElement({
					className: 'day-stats-value',
				});

				let connected = data.count_connected || 0;
				let not_connected = data.count_not_connected || 0;
				
				if (connected == 0 && not_connected == 0) {
					// no data available - show chart for 0 % = same as all not connected 
					not_connected = 1;
				}

				Charts.makeDoughnut(el, [{
					label: _('Dovolané'),
					value: connected,
					color: 'var(--graph-success-color, green)',
				}, {
					label: _('Nedovolané'),
					value: not_connected,
					color: 'var(--graph-error-color, red)',
				}], Formats.percent(data.service_level_ratio || 0));

				return el;
			})()]
		}]);
	},
	
	refreshExpandState() {
		this.el.classList.toggle('expanded', this.expanded);
		if (this.expanded) {
			this.buttonEl.setAttribute('title', _('Skrýt statistiky skupiny'));
			this.buttonEl.gwReplaceChildren([
				Utils.useIcon('collapse'),
			]);
			this.buttonEl.classList.add('icon-only');
			this.buttonEl.classList.remove('icon-left');
			this.wrapEl.gwHide(false);
			this.renderStats({});
			this.loadData();
		} else {
			this.wrapEl.gwHide(true);
			this.buttonEl.setAttribute('title', '');
			this.buttonEl.gwReplaceChildren([
				Utils.useIcon('expand'),
				_('Statistiky skupiny'),
			]);
			this.buttonEl.classList.add('icon-left');
			this.buttonEl.classList.remove('icon-only');
		}
	},
	
	async loadData() {
		if (!this.expanded) return;
		let signal = Utils.abortAndRetry(this, 'reload');
		const data = await REST.GET('supervisor/day-stats', null, {signal});
		this.renderStats(data);
	},

	onBusMessage(msg) {
		if (msg.type === 'CALL_ENDED' && this.expanded) {
			Utils.dedupeCalls(this, 'reload', 500, () => this.loadData());
		}
	},

});

// }}}
// {{{ Supervisor.ActiveCallsScreen

GW.define('Supervisor.ActiveCallsScreen', 'GW.Component', {

	data: null,

	initComponent() {
		const me = this;
		
		Utils.interval(this, 'duration-update', 1000, () => this.updateDurations());

		function formatContact(number) {
			const contact = me.data && me.data.details && me.data.details.contacts.find(c => c.phone == number);
			const info = contact ? [contact.name, contact.company].filter(v => v).join(', ') : '';

			return [{
				textContent: number,
				className: 'caller-number',
			}, {
				':skip': !info,
				textContent: info,
				className: 'caller-info',
			}];
		}
		
		function formatQueue(number) {
			const queue = me.data && me.data.details && me.data.details.queues.find(q => q.queue == number);

			return [{
				':skip': !queue || !queue.name,
				textContent: queue ? queue.name : '',
				className: 'queue-name',
			}, {
				textContent: number,
				className: 'queue-number',
			}];
		}
		
		function formatAgent(callee) {
			const user = me.data && me.data.details && me.data.details.users.find(u => u.extension == callee.number);

			return [{
				':skip': !user,
				textContent: user ? user.name : '',
				className: 'callee-name',
			}, {
				':skip': !callee.number,
				textContent: callee.number,
				className: 'callee-number',
			}, {
				':skip': !callee.more,
				children: [{
					nodeName: 'em',
					textContent: _('Více agentů'),
				}],
			}];
		}

		let activeCallsTable = {
			xtype: 'SmartTable',
			extraClass: 'hoverable',
			ref: 'tableActive',

			renderRow(tr, row) {
				tr.classList.toggle('active-chanspy', me.isChanSpyActive(row['channel']));
			},

			getColumns() {
				return [{
					id: 'caller',
					name: _('Volající'),
					formatCell(td, v, row) {
						td.gwReplaceChildren(formatContact(v));
					},
				}, {
					id: 'queue',
					name: _('Fronta'),
					formatCell(td, v, row) {
						td.gwReplaceChildren(formatQueue(v));
					},
				}, {
					id: 'queue_join_ts',
					name: _('Začátek hovoru'),
					format: 'time',
				}, {
					id: 'duration',
					name: _('Délka hovoru'),
					formatCell(td, v, row) {
						td.classList.add('js-duration');
						td.$duration_start = row['start_ts'];
					},
				}, {
					id: 'callee',
					name: _('Agent'),
					formatCell(td, v, row) {
						td.gwReplaceChildren(formatAgent(v));
					},
				}, {
					id: 'ctl',
					name: _('Akce'),
					formatCell: (td, v, row) => {
						me.renderActiveCallButtons(td, row);
					}
				}];
			},
		};

		let waitingCallsTable = {
			xtype: 'SmartTable',
			extraClass: 'hoverable table-waiting',
			ref: 'tableWaiting',
			getColumns() {
				return [{
					id: 'caller',
					name: _('Volající'),
					formatCell(td, v, row) {
						td.gwReplaceChildren(formatContact(v));
					},
				}, {
					id: 'queue',
					name: _('Fronta'),
					formatCell(td, v, row) {
						td.gwReplaceChildren(formatQueue(v));
					},
				}, {
					id: 'queue_join_ts',
					name: _('Vstup do fronty'),
					format: 'time',
				}, {
					id: 'duration',
					name: _('Doba ve frontě'),
					formatCell(td, v, row) {
						td.classList.add('js-duration');
						td.$duration_start = row['queue_join_ts'];
					},
				}, {
					id: 'callee',
					name: _('Agent'),
					formatCell(td, v, row) {
						td.gwReplaceChildren(formatAgent(v));
					},
				}];
			},
		};

		this.el = document.gwCreateElement({
			className: 'js-msgbus',
			socketSubscriptions: ['call_updates'],
			children: [{
				ref: 'filter',
				xtype: 'Widgets.ButtonSwitcher',
				cls: 'button-switcher small light',
				items: [{
					id: 'all',
					title: _('Všechny'),
				}, {
					id: 'active',
					title: _('Aktivní'),
				}, {
					id: 'waiting',
					title: _('Čekající'),
				}],
				'on:beforeselect': (c, i) => {
					Application.route({
						paramsFn: params => {
							params.set('table', i.id);
							return params;
						},
					});
				},
			}, {
				className: 'button-switcher-content',
				children: [{
					ref: 'callsActive',
					children: [{
						className: 'table-title',
						textContent: _('Aktivní hovory'),
					}, activeCallsTable]
				}, {
					ref: 'callsWaiting',
					children: [{
						className: 'table-title',
						textContent: _('Čekající hovory'),
					}, waitingCallsTable],
				}],
			}]
		}, this);

		this.initChanSpy();
	},

	releaseComponent() {
		this.stopChanSpy();
	},

	renderActiveCallButtons(td, call) {
		if (this.isChanSpyActive(call.channel)) {
			td.gwCreateChild({
				nodeName: 'button',
				className: 'small secondary static icon-only',
				title: _('Příposlech aktivní'),
				children: [{
					nodeName: 'img',
					src: APP_BASE + 'img/dialing-animation.gif',
					className: 'icon',
				}],
			});

			td.gwCreateChild({
				nodeName: 'button',
				className: 'small secondary icon-only',
				title: _('Opustit příposlech'),
				children: [Utils.useIcon('logout')],
				'on:click': () => this.hangupSpyingChannel(call.channel),
			});
		} 
		td.gwCreateChild({
			nodeName: 'button',
			className: 'small secondary icon-only select-input',
			title: _('Zahájit příposlech'),
			children: [Utils.useIcon('headphones')],
			disabled: !!this.spyBusy,
			'on:click': e => this.showChanSpyPopup(e, call),
		});

		td.gwCreateChild({
			nodeName: 'button',
			className: 'small error icon-only',
			title: _('Zavěsit'),
			children: [Utils.useIcon('phone-hangup')],
			'on:click': () => this.hangup(call.channel),
		});
	},
	
	showChanSpyPopup(ev, call) {
		let popup = new PopupMenu({
			options: [{
				text: _('Zahájit příposlech'),
				handle: () => this.startChanSpy(call.channel, null),
			}, {
				text: _('Přesměrovat příposlech na číslo'),
				handle: () => this.showChanSpyDialog(call),
			}],
		});

		PopupManager.show(popup, {
			anchorEl: ev.target.closest('button'),
			forceAxis: 'vertical',
			preferReadingOrder: true,
		});
	},
	
	showChanSpyDialog(call) {
		
		let me = this;
		
		new Main.Dialog({

			title: _('Přesměrovat příposlech'),

			'after:initComponent'() {
				let dlg = this;
				this.bodyEl.gwCreateChild({
					xtype: 'Office.DialerInput',
					'after:initComponent'() {
						this.setButtons([{
							id: 'chanspy',
							icon: 'headphones',
							cls: 'success icon-only',
							title: _('Přesměrovat příposlech'),
						}]);
					},
					'on:select': (c, contact) => {
						me.startChanSpyOriginate(call.channel, c.sanitizeNumber(contact.number));
						dlg.close();
					},
					'on:submit': (c, number) => {
						me.startChanSpyOriginate(call.channel, number);
						dlg.close();
					},
					'on:buttonclick': (c, btn) => {
						me.startChanSpyOriginate(call.channel, c.getNumber());
						dlg.close();
					},
				});
			},
		});
	},

	hangup(channel) {
		let me = this;

		new Main.ConfirmDialog({
			confirmCls: 'error',
			title: _('Opravdu si přejete hovor zavěsit?'),

			async onSave() {
				await REST.POST('supervisor/hangup-call', {channel});
				me.reload();
			},
		});
	},

	updateDurations() {
		for (let td of this.el.querySelectorAll('.js-duration')) {
			if (td.$duration_start) {
				td.textContent = Utils.getElapsedTime(td.$duration_start);
			}
		}
	},

	updateTables(which = 'both') {
		if (!this.data) {
			return;
		}

		if (which === 'both' || which === 'active') {
			this.tableActive.setData(this.data.calls.filter(c => c.start_ts));
		}

		if (which === 'both' || which === 'waiting') {
			this.tableWaiting.setData(this.data.calls.filter(c => !c.start_ts));
		}

		this.updateDurations();
	},

	/*
	 * Channel spying support code.
	 */

	initChanSpy() {
		if (this.webphone) {
			return;
		}

		this.webphone = new Office.WebPhone({
			'on:sessionchange': c => {
				/*
				 * When the spy session ends, we disconnect the
				 * spy phone.
				 */
				if (this.spySession && this.spySession.isEnded()) {
					this.stopChanSpy();
					return;
				}

				this.updateTables('active');
			},
			'on:registrationchange': c => {
				let reg = this.webphone.getRegistrationStatus();
				if (reg.registered || reg.cause) {
					this.webphoneRegistrationCompleter.resolve();
				}
			},
		});
	},

	isChanSpyActive(channel) {
		return this.data && this.data.chanspies.some(chanspy => chanspy.spied_channel == channel);
	},
	
	async startChanSpyOriginate(channel, target) {

		await REST.POST('supervisor/channel-spy-originate', {channel, target});

		Application.notify({
			kind: 'success',
			text: _('Příposlech byl přesměrován'),
			timeout: 3000,
		});
	},

	async startChanSpy(channel) {
		this.stopChanSpy();

		this.webphoneRegistrationCompleter = Utils.makeCompleter();
		this.webphone.connect();
		this.spyBusy = true;
		this.updateTables('active');

		try {
			await Promise.any([this.webphoneRegistrationCompleter, Utils.timeoutPromise(3000)]);

			let reg = this.webphone.getRegistrationStatus();
			if (!reg.registered) {
				let msg = reg.cause_message || _('Selhala registrace odposlouchávacího zařízení');

				throw new Error(_('Odposlech není možný.') + ' ' + msg);
			}

			let result = await REST.POST('supervisor/channel-spy', {channel});

			this.spySession = this.webphone.call(result.exten);
			this.spySession.channel = channel;
			this.spyBusy = false;

			this.updateTables('active');
		} catch(ex) {
			this.stopChanSpy();
			throw ex;
		}
	},

	stopChanSpy() {
		if (this.spySession) {
			if (!this.spySession.isEnded()) {
				this.spySession.terminate();
			}

			this.spySession = null;
		}

		this.webphone.disconnect();
		this.spyBusy = false;
	},
	
	async hangupSpyingChannel(channel) {
		await REST.POST('supervisor/channel-spy-hangup', {channel});
		this.updateTables('active');
	},

	async reload() {
		let signal = Utils.abortAndRetry(this, 'reload');

		this.data = await REST.GET('all-queue-calls', null, {signal});
		this.updateTables();
	},

	async applyParams(params) {
		const table = params.get('table') || 'all';

		this.filter.setSelected(table);
		
		this.callsActive.className = table === 'active' || table === 'all' ? 'visible' : 'hidden';
		this.callsWaiting.className = table === 'waiting' || table === 'all' ? 'visible' : 'hidden';
		
		await this.reload();
	},

	onBusMessage(msg) {
		if (msg.type === 'CALL_CHANGED') {
			Utils.dedupeCalls(this, 'reload', 500, () => this.reload());
		}
	},
});

// }}}
// {{{ Supervisor.autoHideMixin

Supervisor.autoHideMixin = function() {
	const containerSelector = '.queue-list';
	function getExpander(ct) {
		return ct.parentNode.querySelector('.expander');
	};

	return {
		renderAutoHideButton() {
			return {
				nodeName: 'button',
				className: 'transparent expander hidden',
				children: [{
					textContent: _('Více'),
					className: 'label',
				}, {
					className: 'count',
				}],
				'on:click': ev => {
					let expandContainer = ev.currentTarget.closest(containerSelector) || ev.currentTarget.parentNode.querySelector(containerSelector);
					let expandResult = expandContainer.classList.toggle('expanded');

					ev.currentTarget.querySelector('.label').textContent = expandResult ? _('Méně') : _('Více');
					ev.currentTarget.querySelector('.count').style.display = expandResult ? 'none' : null;

					this.updateAutoHide([expandContainer]);
				},
			};
		},

		updateAutoHide(els) {
			for (let el of els) {
				let expander = getExpander(el);

				if (el.clientHeight < el.scrollHeight) {
					expander.classList.remove('hidden');
					let expanderCount = expander.querySelector('.count');
					let agentsElements = el.querySelectorAll('.agent, .queue');
					let containerPos = el.getBoundingClientRect();

					let visibleItems = 0;
					for (let agentEl of agentsElements) {
						let agentPos = agentEl.getBoundingClientRect();

						if (agentPos.top - containerPos.top + agentPos.height <= el.clientHeight) {
							visibleItems += 1;
						}
					}

					let hiddenItems = agentsElements.length - visibleItems;
					expanderCount.textContent = ` (${hiddenItems})`;
				} else {
					if (!el.classList.contains('expanded')) {
						expander.classList.add('hidden');
					}
				}
			}
		},

		initAutoHide() {
			this.finiAutoHide();

			let updateOverflowDebounced = els => {
				clearTimeout(this.updateOverflowTimer);

				this.updateOverflowTimer = setTimeout(() => this.updateAutoHide(els), 250);
			};

			this.resizeObserver = new ResizeObserver(entries => {
				updateOverflowDebounced(entries.map(entry => entry.target));
			});

			for (let el of this.el.querySelectorAll(containerSelector)) {
				this.resizeObserver.observe(el);
			}
		},

		finiAutoHide() {
			if (this.resizeObserver) {
				clearTimeout(this.updateOverflowTimer);
				this.updateOverflowTimer = null;

				this.resizeObserver.disconnect();
				this.resizeObserver = null;
			}
		},
	};
};

// }}}
// {{{ Supervisor.collapseToggleMixin

/*
 * Usage:
 *
 * - call initCollapseToggle() from initComponent of extended class
 * - call collapseToggleRefresh() after reloading the list of collapsible items
 * - identify collapse buttons with `collapseAllButtonSelector` and `collapseItemButonSelector`
 */
Supervisor.collapseToggleMixin = function({
	storageKey,
	itemContainerSelector,
	collapseAllButtonSelector = '.collapse-toggle-button',
	collapseItemButonSelector = '.collapse-button',
}) {
	return {
		initCollapseToggle() {
			let me = this;
			let user = Application.session.user.id;
			let collapsedItems = new Set(Utils.getLocalState({user, key: storageKey}, []));

			function save() {
				Utils.setLocalState({user, key: storageKey}, [...collapsedItems]);
			}

			function setCollapsed(id, collapsed) {
				collapsedItems[collapsed ? 'add' : 'delete'](id);
				save();
			}

			function isExpandedAll() {
				return !me.el.querySelector('.collapsed' + itemContainerSelector);
			}

			function collapseAll() {
				collapsedItems = new Set();

				me.el.querySelectorAll(itemContainerSelector).forEach(el => {
					el.classList.add('collapsed');
					collapsedItems.add(el.dataset.id);
				});

				save();
			}

			function expandAll() {
				collapsedItems = new Set();

				me.el.querySelectorAll(itemContainerSelector).forEach(el => {
					el.classList.remove('collapsed');
				});

				save();
			}

			function updateCollapseAllButton() {
				let allExpanded = isExpandedAll();

				for (let el of me.el.querySelectorAll(collapseAllButtonSelector)) {
					el.gwReplaceChildren(allExpanded
						? [Utils.useIcon('collapse'), _('Sbalit vše')]
						: [Utils.useIcon('expand'), _('Rozbalit vše')]
					);
				}
			}

			/*
			 * Should be called after the using componenet reloads
			 * the list of collapsible items.
			 */
			this.collapseToggleRefresh = function() {
				this.el.querySelectorAll(itemContainerSelector).forEach(el => {
					el.classList.toggle('collapsed', collapsedItems.has(el.dataset.id));
				});

				updateCollapseAllButton();
			};

			this.el.addEventListener('click', ev => {
				if (ev.target.closest(collapseAllButtonSelector)) {
					if (isExpandedAll()) {
						collapseAll();
					} else {
						expandAll();
					}

					updateCollapseAllButton();
				}

				if (ev.target.closest(collapseItemButonSelector)) {
					let itemCt = ev.target.closest(itemContainerSelector);

					setCollapsed(itemCt.dataset.id, itemCt.classList.toggle('collapsed'));
					updateCollapseAllButton();
				}
			}, true);
		},
	};
};

// }}}
// {{{ Supervisor.AgentsScreen

GW.define('Supervisor.AgentsScreen', 'GW.Component', {
	data: null,
	
	pauseTypes: null,

	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus toolbar',
			socketSubscriptions: ['call_updates', 'client_connections', 'user_changes', 'queues'],
			children: [{
				className: 'toolbar-top',
				children: [{
					ref: 'filterEl',
					xtype: 'Widgets.ButtonSwitcher',
					cls: "button-switcher small light",
					'on:beforeselect': (c, i) => {
						Application.route({
							paramsFn: params => {
								params.set('filter', i.id);
								return params;
							},
						});
					},
				}, {
					ref: 'fulltextEl',
					nodeName: 'input',
					type: 'search',
					className: 'small',
					placeholder: _('Hledat agenta nebo linku'),
					'on:input': (c, i) => {
						Application.route({
							paramsFn: params => {
								params.set('fulltext', c.target.value);
								return params;
							},
						});
					},
				}, {
					nodeName: 'button',
					className: 'collapse-toggle-button secondary icon-left small',
				}],
			}, {
				ref: 'dataEl',
				className: 'button-switcher-content',
			}]
		}, this);

		this.initCollapseToggle();

		this.updateFilters();
		this.reload();
		this.loadPauseTypes();

		Utils.interval(this, 'timers-update', 1000, () => this.updateTimers());
	},

	'before:destroy'() {
		this.finiAutoHide();
	},
	
	updateTimers() {
		if (!this.el) {
			return;
		}
		
		const pause_time = (pause) => {
			if (!pause || !pause.start_ts) {
				return '';
			}
			const duration = pause.end_ts ? (pause.end_ts - Date.now()) : (Date.now() - pause.start_ts);
			return Formats.duration_unpadded(Math.max(0, duration));
		};
		this.el.querySelectorAll('.pause-timer').forEach(el => {
			el.textContent = ' ' + pause_time(el.$pause);
		});
		
		this.el.querySelectorAll('.active-call-dial-ts-timer').forEach(el => {
			el.textContent = ' ' + Formats.duration(Date.now() - el.$dialTs);
		});
	},

	subscribedFilter: user => user.queues.some(q => q.state === 'subscribed' || q.state === 'paused'),

	updateFilters() {
		const total = this.data && this.data.length;
		const subscribed = this.data && this.data.filter(this.subscribedFilter).length;
		const notSubscribed = this.data && (total - subscribed);

		this.filterEl.setItems([{
			id: 'all',
			title: _('Všichni') + (this.data ? ' (' + total + ')' : ''),
		}, {
			id: 'subscribed',
			title: _('Přihlášení') + (this.data ? ' (' + subscribed + ')' : ''),
		}, {
			id: 'not_subscribed',
			title: _('Nepřihlášení') + (this.data ? ' (' + notSubscribed + ')' : ''),
		}]);

		if (!Application.isMobileUI()) {
			this.fulltextEl.focus();
		}
	},

	renderAgentStatus(user) {
		const subcribedQueues = user.queues.filter(q => q.state === 'subscribed' || q.state === 'paused');
		const withPauseTypes = this.pauseTypes && this.pauseTypes.length > 0;
		
		const webrtc_reachable = user.devices && user.devices.some(d => d.kind === 'webrtc' && d.reachable);
		const phone_reachable  = user.devices && user.devices.some(d => d.kind !== 'webrtc' && d.reachable);

		function countAsFree() {
			if (user.followme) {
				// skip any further checks
				return Application.getActiveUserGroup().options.free_agent_include_followme;
			}
			if (!user.devices || !user.devices.some(d => d.reachable)) {
				return false;
			}
			if (Application.getActiveUserGroup().options.free_agent_only_agent_app && !user.session_exists) {
				return false;
			}
			return true;
		}

		return {
			className: 'agent-status',
			children: [{
				className: 'agent-title',
				children: [{
					textContent: user.name,
					title: user.name,
				}, {
					className: 'agent-extension-select',
					xtype: 'Main.ExtensionSelector',
					userId: user.user_id,
					getCurrentExtension: () => Main.ExtensionSelector.getSelectedExtensionOfUser(user),
				}]
			}, {
				className: 'status-container button xs icon-left static grey',
				children: [
					Utils.useIcon('dot', {cls: webrtc_reachable ? 'success' : 'muted'}),
					{textContent: webrtc_reachable ? _('Online') : _('Offline'),}
				],
			}, {
				className: 'status-container button xs icon-left static grey',
				children: [
					Utils.useIcon('dot', {cls: phone_reachable ? 'success' : 'muted'}),
					Utils.useIcon('telephone',  {cls: phone_reachable ? '' : 'muted'}), // TODO test
				],
			}, {
				className: 'status-container button xs icon-left static grey',
				children: [
					Utils.useIcon('queue', {cls: subcribedQueues.length > 0 ? 'success' : 'muted'}),
					{
						textContent: subcribedQueues.length + '/' + user.queues.length,
					}
				],
				title: subcribedQueues.length > 0 ?
					(subcribedQueues.length > 1 ?
						_n(subcribedQueues.length, 'Agent je přihlášen ve {n} frontách') :
						_('Agent je přihlášen v jedné frontě')) :
					_('Agent není přihlášen v žádné frontě')
			}, {
				':skip': !(subcribedQueues.length > 0 && !phone_reachable && !webrtc_reachable && !user.followme),
				className: 'status-container button xs icon-only static error',
				children: [Utils.useIcon('warningsign')],
				title: _('Agent je přihlášen ve frontách, ale nemá registrované žádné zařízení!'),
			}, {
				':skip': !(subcribedQueues.length === 0 && (phone_reachable || webrtc_reachable || user.followme)),
				className: 'status-container button xs icon-only static error-secondary',
				children: [Utils.useIcon('warningsign')],
				title: _('Agent není přihlášen ani v jedné frontě!'),
			}, {
				':skip': !(subcribedQueues.length === 0 && !phone_reachable && !webrtc_reachable && !user.followme),
				className: 'status-container button xs icon-left static grey',
				children: [ Utils.useIcon('error'), {textContent: _('Nedostupný')} ],
			}, {
				':skip': !(subcribedQueues.length > 0 && (webrtc_reachable || phone_reachable) && !user.in_call && !user.pause && countAsFree()),
				className: 'status-container button xs icon-left static grey',
				children: [ Utils.useIcon('checkmarkcircle', {cls: 'success'}), {textContent: _('Volný')} ],
				title: _('Aktuálně neprobíhá žádný hovor'),
			}, {
				':skip': !(!user.in_call && !user.pause && user.followme),
				className: 'status-container button xs icon-left static grey',
				children: [ Utils.useIcon('checkmarkcircle'), {textContent: _('Externí linka')} ],
				title: _('Agent je přihlášen na externí lince'),
			}, {
				':skip': !(subcribedQueues.length > 0 && user.in_call),
				className: 'status-container button xs icon-left static primary',
				children: [
					Utils.useIcon('phone'),
					{
						textContent: _('Hovoří')
					}, {
						$dialTs: user.active_call_dial_ts,
						className: 'active-call-dial-ts-timer',
					}
				],
			}, {
				className: 'controls',
				children: [{
					nodeName: 'button',
					'attr:data-state': user.pause ? 'paused' : 'not-paused',
					className: `status-container button xs icon-left ${user.pause ? 'warning' : 'grey'} ${withPauseTypes ? 'with-pause-types' : ''}`,
					disabled: !user.queues.some(q => q.state === 'subscribed' || q.state === 'paused'),
					children: [ 
						Utils.useIcon( user.pause ? 'play' : 'pause', {cls: user.pause ? undefined : 'warning'}), 
						(user.pause ? {
							title: (user.pause.pause_type ? user.pause.pause_type.name : null),
							children: [{
								textContent: _('Zrušit pauzu'),
							}, {
								':skip': !user.pause.pause_type,
								textContent: (user.pause.pause_type ? ' (' + user.pause.pause_type.name + ')' : ''),
								className: 'pause-name',
							}, {
								$pause: user.pause,
								className: 'pause-timer',
							}]
						} : {
							textContent: _('Zapnout pauzu')
						}),
					],
					'on:click': async ev => {
						ev.preventDefault();

						if (!user.extension) {
							return;
						}
						
						if (user.pause) {
							await REST.POST('queues/all/exten/' + encodeURIComponent(user.extension) + '/unpause');
						} else {
							await this.pauseWithPauseTypes(ev.target.closest('button'), user.extension);
						}
					},
				}, {
					nodeName: 'button',
					':skip': !user.extension,
					className: 'more transparent xs icon-only status-container button',
					children: [Utils.useIcon('vdots', {cls: 'xs'})],
					'on:click': ev => {
						ev.preventDefault();
						let popup = new PopupMenu({
							options: [{
								iconName: 'login',
								text: _('Přihlásit do všech front'),
								async handle() {
									await REST.POST('queues/all/exten/' + encodeURIComponent(user.extension) + '/join');
								},
							}, {
								iconName: 'logout',
								text: _('Odhlásit ze všech front'),
								async handle() {
									await REST.POST('queues/all/exten/' + encodeURIComponent(user.extension) +'/leave/');
								},
							}],
						});
						PopupManager.show(popup, {
							anchorEl: ev.target,
							forceAxis: 'vertical',
							preferReadingOrder: true,
						});
					},
				}],
			}],
		};
	},
	
	async loadPauseTypes() {
		let signal = Utils.abortAndRetry(this, 'pause-types-reload');
		this.pauseTypes = await REST.GET('pause-types', null, {signal});
		return this.pauseTypes;
	},
	
	async pauseWithPauseTypes(anchorEl, extension) {
		const types = this.pauseTypes !== null ? this.pauseTypes : await this.loadPauseTypes();
		if (types.length > 0) {
			let popup = new PopupMenu({
				options: types.map(pause_type => ({
					text: pause_type.name,
					async handle() {
						await REST.POST('queues/all/exten/' + encodeURIComponent(extension) + '/pause', {
							pause_type: pause_type.id,
						});
					},
				})),
			});
			PopupManager.show(popup, {
				anchorEl,
				forceAxis: 'vertical',
				preferReadingOrder: true,
			});
		} else {
			// no pause types available, do not show popup, just pause queue
			await REST.POST('queues/all/exten/' + encodeURIComponent(extension) + '/pause');
		}
	},
	
	renderAgentPresence(presence) {
		const hours_to_ms = h => h * 3600 * 1000;
		
		const call = presence.call || 0;
		const pause = presence.pause || 0;
		const free = presence.free || 0;
		const login = presence.login || 0;
		
		const total = call + pause + free + login;
		const width = (
			total > hours_to_ms(6) ? 160 :
			total > hours_to_ms(4) ? 120 :
			total > hours_to_ms(2) ? 80 :
			40
		);

		const getTooltipContent = function (text, total, value, percent) {
			let content = text + ' - ' + Formats.duration_unpadded(typeof value !== 'undefined' ? value : total);
			if (total && typeof percent !== 'undefined') {
				content += ` (${percent}%)`;
			}
			return content;
		};

		// scale items such as the sum of all items is total, all items are rounded to integer and make sure
		const scale_array_rounded = (items, total) => {
			if (items.length === 0) return [];
			const sum = items.reduce((a, b) => a + b);
			const parts = items.map(n => Math.round(n / sum * total));
			const parts_sum = parts.reduce((a, b) => a + b);
			// fix the last item to make the sum to be same as total. There can be a difference due to rounding.
			parts[parts.length - 1] += total - parts_sum; 
			return parts;
		};
		const scale_times = (total) => scale_array_rounded([call, pause, free, login], total);

		const [call_percent, pause_percent, free_percent, login_percent] = scale_times(100);

		const title_in_call = getTooltipContent(_('V hovoru'), total, call, call_percent);
		const title_pause   = getTooltipContent(_('V pauze'), total, pause, pause_percent);
		const title_free    = getTooltipContent(_('Volný'), total, free, free_percent);
		const title_login   = getTooltipContent(_('Přihlášen'), total, login, login_percent);
		const title_total   = getTooltipContent(_('Celkem'), total);
		const title_first   = `${_('Čas prvního přihlášení')} - ${Formats.time(presence.login_first_ts)}`;
		const title_last    = `${_('Čas posledního odhlášení')} - ${presence.login_last_ts ? Formats.time(presence.login_last_ts) : ''}`;


		const [call_width, pause_width, free_width, login_width] = scale_times(width);

		return {
			className: 'value agent-statistics-presence',
			children: [{
				className: 'chart',
				style: `width: ${width}px`,
				children: [{
					className: 'in_call',
					style: `width: ${call_width}px`,
					title: title_in_call
				},{
					className: 'pause',
					style: `width: ${pause_width}px`,
					title: title_pause
				},{
					className: 'free',
					style: `width: ${free_width}px`,
					title: title_free
				},{
					className: 'login',
					style: `width: ${login_width}px`,
					title: title_login
				}]
			}, {
				className: 'label',
				children: [
					{ nodeName: 'span', textContent: Formats.duration_short(call) },
					{ nodeName: 'span', textContent: ' | ', className: 'text-muted' },
					{ nodeName: 'span', textContent: Formats.duration_short(pause) },
					{ nodeName: 'span', textContent: ' | ', className: 'text-muted' },
					{ nodeName: 'span', textContent: Formats.duration_short(free) },
					{ nodeName: 'span', textContent: ' | ', className: 'text-muted' },
					{ nodeName: 'span', textContent: Formats.duration_short(login) },
					{ nodeName: 'span', textContent: ' | ', className: 'text-muted' },
					{ nodeName: 'span', textContent: Formats.duration_short(total) },
				],
				title: [
					title_in_call, 
					title_pause,
					title_free,
					title_login,
					title_total,
					title_first,
					title_last,
				].join('\n'),
			}],
		}
	},

	renderAgentStatistics(presence, stats) {
		
		return {
			className: 'agent-statistics',
			children: [{
				className: 'agent-statistics-item hide-on-collapse',
				children: [{
					textContent: _('Docházka'),
					className: 'title',
				}, this.renderAgentPresence(presence)],
			}, {
				className: 'agent-statistics-item',
				children: [{
					textContent: _('Celkem hovorů'),
					className: 'title',
				}, {
					textContent: stats.count || 0,
					className: 'value',
				}],
			}, {
				className: 'agent-statistics-item',
				children: [{
					textContent: _('Dovolané'),
					className: 'title',
				}, {
					textContent: stats.count_connected || 0,
					className: 'value',
				}],
			}, {
				className: 'agent-statistics-item',
				children: [{
					textContent: _('Nedovolané'),
					className: 'title',
				}, {
					textContent: stats.count_not_connected || 0,
					className: 'value',
				}],
			}, {
				className: 'agent-statistics-item hide-on-collapse',
				children: [{
					textContent: _('Průměrné vyzvánění'),
					className: 'title',
				}, {
					textContent: Formats.duration(stats.avg_ring_duration),
					className: 'value',
				}],
			}, {
				className: 'agent-statistics-item hide-on-collapse',
				children: [{
					textContent: _('Průměrný hovor'),
					className: 'title',
				}, {
					textContent: Formats.duration(stats.avg_duration),
					className: 'value',
				}],
			}, {
				className: 'agent-statistics-item hide-on-collapse',
				children: [{
					textContent: _('Celková doba hovorů'),
					className: 'title',
				}, {
					textContent: Formats.duration(stats.sum_duration),
					className: 'value',
				}],
			}, {
				className: 'agent-statistics-item',
				children: [{
					textContent: _('Service level'),
					className: 'title hide-on-collapse',
				}, (() => {
					let el = document.gwCreateElement({
						className: 'value agent-statistics-item-graph',
					});

					if (!stats || Object.keys(stats).length === 0) {
						return el;
					}

					Charts.makeDoughnut(el, [{
						label: _('Dovolané'),
						value: stats.count_connected,
						color: 'var(--graph-success-color, green)',
					}, {
						label: _('Nedovolané'),
						value: stats.count_not_connected,
						color: 'var(--graph-error-color, red)',
					}], Formats.percent(stats.service_level_ratio));

					return el;
				})()],
			}],
		};
	},

	renderQueue(user, queue) {
		return {
			nodeName: 'button',
			className: 'queue',
			'attr:data-status': (user && user.active_calls_queues && user.active_calls_queues.includes(queue.queue)) ? 'in-queue-call' : queue.state, // unsubscribed subscribed paused
			'attr:data-static': queue.static_membership ? '1' : '0',
			'attr:data-type': queue.kind,
			title: queue.static_membership ? _c('Přihlášen trvale', 'queue') : undefined,
			children: [{
				className: 'status',
			}, {
				className: 'info' + (!queue.name ? ' no-name' : ''),
				children: [{
					className: 'name',
					textContent: queue.name,
				}, {
					className: 'number',
					textContent: queue.queue + (queue.penalty ? (' (P' + queue.penalty + ')') : ''),
				}],
			}],
			'on:click': async () => {
				if (queue.static_membership) {
					return;
				}

				if (queue.state === 'unsubscribed') {
					await REST.POST('queues/' + encodeURIComponent(queue.queue) + '/exten/' + encodeURIComponent(user.extension) + '/join');
				} else {
					await REST.POST('queues/' + encodeURIComponent(queue.queue) + '/exten/' + encodeURIComponent(user.extension) + '/leave');
				}
			},
		};
	},

	renderAgent(user) {
		return {
			className: 'agent-container panel-container',
			'attr:data-id': user.user_id,
			children: [{
				className: 'agent-info',
				children: [
					this.renderAgentStatus(user),
					this.renderAgentStatistics(user.presence, user.stats),
				{
					nodeName: 'button',
					className: 'collapse-button transparent icon-only small',
					children: [Utils.useIcon('arrow-simple-up')],
				}],
			}, {
				className: 'queue-control-panel wrap',
				children: [{
					className: 'queue-list',
					children: user.queues.map(queue => this.renderQueue(user, queue)),
				}, this.renderAutoHideButton()],
			}],
		};
	},

	...Supervisor.autoHideMixin(),

	...Supervisor.collapseToggleMixin({
		storageKey: 'supervisor-agents-screen-collapsed',
		itemContainerSelector: '.agent-container',
	}),

	updateData() {
		const filter = this.filterEl.getSelected();
		const fulltext = this.fulltextEl.value;
		
		const filteredData = (this.data || []).filter(user => {
			
			let fulltextPredicate = true;

			if (fulltext.length) {
				const fulltextLowerUnaccented = TextUtils.unaccent(fulltext).trim().toLowerCase();
				fulltextPredicate = [TextUtils.unaccent(user.name).toLowerCase(), String(user.extension || "")].some(el => el.includes(fulltextLowerUnaccented));
			}

			if (filter === 'all') {
				return fulltextPredicate && true;
			}

			if (filter === 'subscribed') {
				return fulltextPredicate && this.subscribedFilter(user);
			}

			if (filter === 'not_subscribed') {
				return fulltextPredicate && !this.subscribedFilter(user);
			}
		});

		let saveScroll = () => {
			let state = new Map(Array.from(this.dataEl.querySelectorAll('.queue-list')).map(ql => {
				let agent = ql.closest('.agent-container').dataset.id;

				return [agent, {
					queue_scroll: ql.scrollLeft,
				}];
			}));

			return () => {
				this.dataEl.querySelectorAll('.queue-list').forEach(ql => {
					let agent = ql.closest('.agent-container').dataset.id;
					let agent_state = state.get(agent);
					if (agent_state) {
						ql.scrollLeft = agent_state.queue_scroll;
					}
				});
			};
		};

		if (this.data) {
			if (filteredData.length) {
				let restore = saveScroll();

				this.dataEl.gwReplaceChildren(filteredData.map(user => this.renderAgent(user)));

				restore();
			} else {
				this.dataEl.gwReplaceChildren([{
					className: 'agent-container panel-container not-found',
					children: [{
						className: 'not-found-label',
						textContent: _('Zadanému filtru neodpovídá žádný agent')
					}],
				}]);
			}
		}

		this.initAutoHide();
		this.updateTimers();
		this.collapseToggleRefresh();
	},

	async reload() {
		let signal = Utils.abortAndRetry(this, 'reload');

		this.data = await REST.GET('supervisor/queues-agents', null,{signal});
		this.updateFilters();
		this.updateData();
	},

	applyParams(params) {
		const filter = params.get('filter') || 'all';
		const fulltext = params.get('fulltext') || '';

		this.filterEl.setSelected(filter);
		this.fulltextEl.value = fulltext;
		this.updateData();
	},

	onBusMessage(msg) {
		let monitored_msgs = [
			'CALL_CHANGED',
			'CLIENT_CONNECTED',
			'CLIENT_DISCONNECTED',
			'USERS_CHANGED',
			'QUEUES_CHANGED',
		];

		if (monitored_msgs.includes(msg.type)) {
			Utils.dedupeCalls(this, 'reload', 500, () => this.reload());
		}
	},
});

// }}}
// {{{ Supervisor.QueuesScreen

GW.define('Supervisor.QueuesScreen', 'GW.Component', {
	data: null,

	pauseTypes: null,

	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus toolbar',
			socketSubscriptions: ['call_updates', 'client_connections', 'user_changes', 'queues'],
			children: [{
				className: 'toolbar-top',
				children: [{
					ref: 'fulltextEl',
					nodeName: 'input',
					type: 'search',
					className: 'small',
					placeholder: _('Hledat název nebo číslo fronty'),
					'on:input': (c, i) => {
						Application.route({
							paramsFn: params => {
								params.set('fulltext', c.target.value);
								return params;
							},
						});
					},
				}, {
					nodeName: 'button',
					className: 'collapse-toggle-button secondary icon-left small',
				}],
			}, {
				className: 'button-switcher-content',
				ref: 'dataEl',
			}]
		}, this);

		this.initCollapseToggle();

		this.reload();
		this.loadPauseTypes();
		this.updateFilters();
	},

	'before:destroy'() {
		this.finiAutoHide();
	},

	getAgentStatus(agent) {
		let state = 'unsubscribed';
		let queueTooltip, agentTooltip;
		let followme = false;

		const onlineState = agent.session_exists ? 'online' : 'offline';
		const onlineTooltip = agent.session_exists ? _('Online') : _('Offline');

		if (agent.state === 'unsubscribed') {
			queueTooltip = _('Nepřihlášen v této frontě');
		} else if (agent.state === 'subscribed' || agent.state === 'paused') {
			queueTooltip = agent.static_membership ? _('Trvale přihlášen v této frontě') : _('Přihlášen v této frontě');
			agentTooltip = _('Volný');
			state = 'subscribed';
			
			if (agent.followme) {
				agentTooltip = _('Externí linka');
				followme = true;
			}

			if (agent.state === 'paused') {
				agentTooltip = _('Má pauzu');
				state = 'paused';
			}

			if (agent.in_call) {
				agentTooltip = _('Hovoří v jiné frontě');
				state = 'incall';
			}

			if (agent.in_call_in_queue) {
				agentTooltip = _('Hovoří v této frontě');
				state = 'incall-inqueue';
			}

			if (!agent.has_device_reachable && !agent.followme) {
				agentTooltip = _('Nemá nastaveno žádné zařízení!');
				state = 'unreachable';
			}
		} else {
			queueTooltip = _('Neznámý stav přihlášení do fronty') + ` [${agent.state}]`;
		}

		return {
			'attr:data-state': state,
			'attr:data-online': onlineState,
			'attr:data-static': agent.static_membership ? '1' : '0',
			'attr:data-followme': followme ? '1' : undefined,
			'title': `${queueTooltip} \n${agentTooltip ? '- ' + agentTooltip + ' ' : ''}(${onlineTooltip})`,
		};
	},

	async loadPauseTypes() {
		let signal = Utils.abortAndRetry(this, 'pause-types-reload');
		this.pauseTypes = await REST.GET('pause-types', null, {signal});
		return this.pauseTypes;
	},

	getAgentMenuItems(queue, agent) {
		return [{
			iconName: agent.state === 'unsubscribed' ? 'login' : 'logout',
			cls: agent.static_membership ? 'disabled' : '',
			text: agent.state === 'unsubscribed' ? _('Přihlásit') : _('Odhlásit'),

			async handle() {
				if (agent.state === 'unsubscribed') {
					await REST.POST('queues/' + encodeURIComponent(queue.queue) + '/exten/' + encodeURIComponent(agent.extension) + '/join');
				} else {
					await REST.POST('queues/' + encodeURIComponent(queue.queue) + '/exten/' + encodeURIComponent(agent.extension) + '/leave');
				}
			},
		}, {
			iconName: agent.state === 'paused' ? 'play' : 'pause',
			cls: !(agent.state === 'subscribed' || agent.state === 'paused') ? 'disabled' : '',
			text: agent.state === 'paused' ?
				(_('Zrušit pauzu') + (agent.pause && agent.pause.pause_type ? ' (' + agent.pause.pause_type.name + ')' : '')) : 
				_('Zapauzovat'),
			
			submenu: agent.state === 'subscribed' && this.pauseTypes && this.pauseTypes.length &&
				this.pauseTypes.map(pauseType => ({
					text: pauseType.name, 
					async handle() {
						await REST.POST('queues/all/exten/' + encodeURIComponent(agent.extension) + '/pause', {
							pause_type: pauseType.id,
						});
					},
				})),

			async handle() {
				if (agent.state === 'subscribed') {
					await REST.POST('queues/all/exten/' + encodeURIComponent(agent.extension) + '/pause');
				} else {
					await REST.POST('queues/all/exten/' + encodeURIComponent(agent.extension) + '/unpause');
				}
			},
		}];
	},

	renderAgent(queue, agent) {
		return {
			className: 'agent queue',
			children: [{
				className: 'status',
				...this.getAgentStatus(agent),
			}, {
				className: 'info',
				children: [{
					className: 'name',
					textContent: agent.name,
				}, {
					className: 'number',
					textContent: agent.extension + (agent.penalty ? (' (P' + agent.penalty + ')') : ''),
				}]
			}, {
				className: 'controls',
				children: [{
					nodeName: 'button',
					className: 'more transparent small',
					children: [Utils.useIcon('vdots')],
					'on:click': async ev => {
						ev.preventDefault();

						if (this.pauseTypes == null) {
							await this.loadPauseTypes();
						}
						
						let popup = new PopupMenu({
							options: this.getAgentMenuItems(queue, agent),
						});

						PopupManager.show(popup, {
							anchorEl: ev.target,
							forceAxis: 'vertical',
							preferReadingOrder: true,
						});
					},
				}],
			}],
		};
	},

	renderQueueAgentsStatus(queue) {
		function queueStat({tooltip, value, icon, iconCls}) {
			return {
				className: 'status-container button xs icon-left static grey',
				children: [Utils.useIcon(icon, {cls: iconCls}), {
					textContent: value,
				}],
				title: tooltip,
			};
		}

		function countAsFree(agent) {
			if (agent.followme) {
				// skip any further checks
				return Application.getActiveUserGroup().options.free_agent_include_followme;
			}
			if (!agent.has_device_reachable) {
				return false;
			}
			if (Application.getActiveUserGroup().options.free_agent_only_agent_app && !agent.session_exists) {
				return false;
			}
			return true;
		}
		
		return {
			className: 'agent-status',
			children: [{
				className: 'agent-title',
				textContent: [queue.name, queue.queue].filter(v => v).join(' - '),
				title: [queue.name, queue.queue].filter(v => v).join(' - '),
			}, ...[{
				icon: 'headphones',
				iconCls: 'success',
				value: (queue.agents.filter(a => a.state === 'subscribed' || a.state === 'paused').length) +
					'/' + queue.agents.length,
				tooltip: _('Přihlášení agenti / Všichni agenti'),
			}, {
				icon: 'checkmarkcircle',
				iconCls: 'success',
				value: queue.agents.filter(a => a.state === 'subscribed' && !a.in_call && countAsFree(a)).length +
					'/' + queue.agents.filter(a => a.state === 'subscribed' && !a.in_call && a.followme).length,
				tooltip: _('Volných agentů / Agenti na externích linkách'),
			}, {
				icon: 'phone-call',
				iconCls: 'primary',
				value: queue.agents.filter(a => a.in_call && (a.state === 'subscribed' || a.state === 'paused')).length,
				tooltip: _('Probíhající hovory'),
			}, {
				icon: 'pause',
				iconCls: 'warning',
				value: queue.agents.filter(a => a.state === 'paused').length,
				tooltip: _('Agentů v pauze'),
			}, {
				icon: 'hourglass',
				iconCls: 'error',
				value: queue.waiting_calls_count,
				tooltip: _('Čekající hovory'),
			}].map(queueStat)],
		};
	},

	renderQueueAgentsStatistics(queue) {
		const trend = queue.stats.trend;
		let totalIcon = Utils.useIcon( 
			      !trend || trend === 0 ? ''      : trend > 0 ? 'arrow-up' : trend < 0 ? 'arrow-down' : 'error', 
			{cls: !trend || trend === 0 ? 'muted' : trend > 0 ? 'error'    : trend < 0 ? 'success'    : 'muted'}
		);

		return {
			className: 'agent-statistics',
			children: [{
				className: 'agent-statistics-item',
				children: [{
					className: 'title',
					textContent: _('Celkem hovorů'),
				}, {
					className: 'value',
					children: [{
						textContent: queue.stats.count || 0,
					}, {
						title: trend,
						children: [totalIcon],
					}],
				}],
			}, {
				className: 'agent-statistics-item',
				children: [{
					className: 'title',
					textContent: _('Dovolané'),
				}, {
					className: 'value',
					textContent: queue.stats.count_connected || 0,
				}],
			}, {
				className: 'agent-statistics-item',
				children: [{
					className: 'title',
					textContent: _('Nedovolané'),
				}, {
					className: 'value',
					textContent: queue.stats.count_not_connected || 0,
				}],
			}, {
				className: 'agent-statistics-item hide-on-collapse',
				children: [{
					className: 'title',
					textContent: _('Průměrně v IVR'),
				}, {
					className: 'value',
					textContent: Formats.duration(queue.stats.avg_early_duration),
				}],
			}, {
				className: 'agent-statistics-item hide-on-collapse',
				children: [{
					className: 'title',
					textContent: _('Průměrné vyzvánění'),
				}, {
					className: 'value',
					textContent: Formats.duration(queue.stats.avg_ring_duration),
				}],
			}, {
				className: 'agent-statistics-item hide-on-collapse',
				children: [{
					className: 'title',
					textContent: _('Průměrný hovor'),
				}, {
					className: 'value',
					textContent: Formats.duration(queue.stats.avg_duration),
				}],
			}, {
				className: 'agent-statistics-item hide-on-collapse',
				children: [{
					className: 'title',
					textContent: _('Celková doba hovorů'),
				}, {
					className: 'value',
					textContent: Formats.duration(queue.stats.sum_duration),
				}],
			}, {
				className: 'agent-statistics-item',
				children: [{
					textContent: _('Service level'),
					className: 'title hide-on-collapse',
				}, (() => {
					let el = document.gwCreateElement({
						className: 'value agent-statistics-item-graph',
					});

					if (!queue.stats || Object.keys(queue.stats).length === 0) {
						return el;
					}

					Charts.makeDoughnut(el, [{
						label: _('Dovolané'),
						value: queue.stats.count_connected,
						color: 'var(--graph-success-color, green)',
					}, {
						label: _('Nedovolané'),
						value: queue.stats.count_not_connected,
						color: 'var(--graph-error-color, red)',
					}], Formats.percent(queue.stats.service_level_ratio));

					return el;
				})()],
			}],
		};
	},

	renderQueue(queue) {
		return {
			className: 'agent-container panel-container',
			'attr:data-id': queue.queue,
			children: [{
				className: 'agent-info',
				children: [
					this.renderQueueAgentsStatus(queue),
					this.renderQueueAgentsStatistics(queue),
				{
					nodeName: 'button',
					className: 'collapse-button transparent icon-only small',
					children: [Utils.useIcon('arrow-simple-up')],
				}],
			}, {
				className: 'queue-control-panel wrap',
				children: [{
					className: 'queue-agents queue-list',
					children: queue.agents.map(agent => this.renderAgent(queue, agent)),
				}, this.renderAutoHideButton()],
			}],
		};
	},

	updateData() {
		const fulltext = this.fulltextEl.value;
		
		const filteredData = (this.data || []).filter(queue => {
			
			let fulltextPredicate = true;
		
			if (fulltext.length) {
				const fulltextLowerUnaccented = TextUtils.unaccent(fulltext).trim().toLowerCase();
				fulltextPredicate = [TextUtils.unaccent(String(queue.name || "")).toLowerCase(), TextUtils.unaccent(String(queue.description || "")).toLowerCase(), String(queue.queue || "")].some(el => el.includes(fulltextLowerUnaccented));
			}

			return fulltextPredicate
		})

		let saveScroll = () => {
			let state = new Map(Array.from(this.dataEl.querySelectorAll('.queue-list')).map(ql => {
				let agent = ql.closest('.agent-container').dataset.id;

				return [agent, {
					queue_scroll: ql.scrollLeft,
				}];
			}));

			return () => {
				this.dataEl.querySelectorAll('.queue-list').forEach(ql => {
					let agent = ql.closest('.agent-container').dataset.id;
					let agent_state = state.get(agent);
					if (agent_state) {
						ql.scrollLeft = agent_state.queue_scroll;
					}
				});
			};
		};

		if (this.data) {
			if (filteredData.length) {
				let restore = saveScroll();

				this.dataEl.gwReplaceChildren(filteredData.map(queue => this.renderQueue(queue)));

				restore();
			} else {
				this.dataEl.gwReplaceChildren([{
					className: 'agent-container panel-container not-found',
					children: [{
						className: 'not-found-label',
						textContent: _('Zadanému filtru neodpovídá žádná fronta')
					}],
				}]);
			}
		}

		this.initAutoHide();
		this.collapseToggleRefresh();
	},

	...Supervisor.autoHideMixin(),

	...Supervisor.collapseToggleMixin({
		storageKey: 'supervisor-queues-screen-collapsed',
		itemContainerSelector: '.agent-container',
	}),

	updateFilters() {
		if (!Application.isMobileUI()) {
			setTimeout(()=>this.fulltextEl.focus(), 250);
		}
	},

	async reload() {
		let signal = Utils.abortAndRetry(this, 'reload');

		this.data = await REST.GET('supervisor/queues', null,{signal});
		this.updateData();
	},

	applyParams(params) {
		const fulltext = params.get('fulltext') || '';

		this.fulltextEl.value = fulltext;
		this.updateData();
	},

	onBusMessage(msg) {
		let monitored_msgs = [
			'CALL_CHANGED',
			'CLIENT_CONNECTED',
			'CLIENT_DISCONNECTED',
			'USERS_CHANGED',
			'QUEUES_CHANGED',
		];

		if (monitored_msgs.includes(msg.type)) {
			Utils.dedupeCalls(this, 'reload', 500, () => this.reload());
		}
	},
});

// }}}
// {{{ Supervisor.CallbacksScreen

GW.define('Supervisor.CallbacksScreen', 'Office.AgentCallbackPanel', {
	buttonSwitcherExtraClass: 'light',
	
	showDialButton() {
		// there is no active OfficeManager on supervisor page, do not show dial button
		return false;
	},
});

// }}}
// {{{ Supervisor.QueuesHistoryScreen

GW.define('Supervisor.QueuesHistoryScreen', 'Office.AgentHistoryPanel', {
	buttonSwitcherExtraClass: 'light',

	showDialButton() {
		// there is no active OfficeManager on supervisor page, do not show dial button
		return false;
	},

	getApiQuery() {
		// disable filtering by current user - get all available calls by ACL
		return {};
	},
});

// }}}

Application.addRoutes([{
	group: 'auth',
	module: 'supervisor',
	path: APP_BASE + 'supervisor',
	async handler({params}) {
		let c = Application.show({
			id: 'supervisor.overview',
			xtype: 'Supervisor.OverviewScreen',
		});

		params.set('screen', 'active-calls');
		c.applyParams(params);
	}
}, {
	group: 'auth',
	module: 'supervisor',
	path: APP_BASE + 'supervisor/{screen:str}',
	async handler({params, captures}) {
		let c = Application.show({
			id: 'supervisor.overview',
			xtype: 'Supervisor.OverviewScreen',
		});

		params.set('screen', captures.screen);
		c.applyParams(params);
	}
}]);

Application.registerModule({
	id: 'supervisor',
	title: _('Supervizor panel'),
	tagline: _('Přehled agentů, front a aktuálních hovorů'),
	icon: 'eye',
	href: APP_BASE + 'supervisor/',
});
